import { httpGET, httpPOST, httpPUT } from '@/services/http'
// import cookies from '@/services/cookies'
// import config from '../../config'

const API_URL = 'https://assetanalysis-socketservices-mo7niavhjq-de.a.run.app/v1'

export const Device = {
  /**
   * gets device vitals by id
   * @param alert_id - alert ID
   */
  getAlertFeedback(filter = {}) {
    return httpGET(`${API_URL}/alert-feedbacks?filter=${JSON.stringify(filter)}`)
  },

  /**
   * gets all inaccuracy-reasons
   */
  getAlertFeedbackReasons() {
    return httpGET(`${API_URL}/inaccuracy-reasons`)
  },

  /**
   * create new feedback
   * working
   */
  createFeedback(feedback) {
    return httpPOST('https://assetanalysis.techolution.com/api/feedback-service/alert/group/feedback', feedback)
  },

  /**
   * update feedback
   */
  updateFeedback(feedback) {
    return httpPUT(`https://assetanalysis.techolution.com/api/feedback-service/alert/group/feedback?feedbackId=${feedback.id}`, feedback)
  },

  /**
   * Gets all the device details
   * @param {*} bedId Bed's ID
   */
  updateFeedbackStatus(deviceId) {
    return httpPUT(`https://assetanalysis.techolution.com/api/feedback-service/dashboard/device/feedback?deviceId=${deviceId}`)
  },

  /**
   * create new feedback
   */
  createNewAlert(alert) {
    return httpPOST(`${API_URL}/alerts`, alert)
  },
  /**
   * Gets all the device details
   * @param {*} deviceId Device's ID
   * @returns { device: Object, vitals: Array, submittedFeedbacks: Array, unsubmittedFeedbacks: Array }
   */
  getCompleteDeviceDetails(deviceId, startDate, endDate) {
    if (startDate && endDate) {
      // return httpGET(`https://assetanalysis.techolution.com/api/feedback-service/alert/patientData?deviceId=${patientId}&startDate=${startDate / 1000}&endDate=${endDate / 1000}`)
      return httpGET(`https://assetanalysis.techolution.com/api/feedback-service/alert/patientData?deviceId=${deviceId}&startDate=${startDate / 1000}&endDate=${endDate / 1000}`)
    }
    // return httpGET(`${config.API_URL}/api/feedback-service/alert/group/session?patientId=${patientId}`)
    return httpGET(`https://assetanalysis.techolution.com/api/feedback-service/alert/patientData?deviceId=${deviceId}`)
  },

  /**
   * Get All device
   * not working
   */
  getAllDevices() {
    return httpGET('https://assetanalysis.techolution.com/api/feedback-service/dashboard/devices')
  }

  // getVitals(patientId) {
  //   return httpGET(`${config.API_URL}/api/patientDetails/vitals?patientId=${patientId}`)
  // }
}
